<table class="list-table" style="word-wrap:break-word; table-layout: fixed; margin-bottom: 10px;">

  <tr>
    <td>Name</td>
    <td>{{ _orderForm.title }} {{ _orderForm.firstName }} {{ _orderForm.lastName?.toUpperCase() }}</td>
  </tr>

  <tr>
    <td>{{"ORDER.SUMMARY.DOB" | translate}}</td>
    <td>{{ _orderForm.dob| date : "dd.MM.yyyy" }}</td>
  </tr>

  <tr>
    <td>{{"ORDER.SUMMARY.NATIONALITY" | translate}}</td>
    <td>{{ _orderForm.nationality }}</td>
  </tr>

  <tr>
    <td>{{"ORDER.SUMMARY.ADDRESS" | translate}}</td>
    <td>{{ _orderForm.address }}, {{ _orderForm.zipCode }} {{ _orderForm.city }}, {{ _orderForm.countryName }}</td>
  </tr>

  <tr>
    <td>{{"ORDER.SUMMARY.EMAIL" | translate}}</td>
    <td>{{ _orderForm.email }}</td>
  </tr>

  <tr>
    <td>{{"ORDER.SUMMARY.PHONE" | translate}}</td>
    <td>+{{ _orderForm.phone }}</td>
  </tr>
  <ng-container *ngIf="_product">
    <tr>
      <td>{{"ORDER.SUMMARY.CONTRACT_PERIOD" | translate}}</td>
      <td>{{ _product.minimalContractPeriodMonths }}  {{"GENERIC.MONTHS" | translate}}</td>
    </tr>
    <tr *ngIf="_product.issuingFee > 0">
      <td>{{"ORDER.SUMMARY.ISSUING_FEE" | translate}}</td>
      <td>{{ _product.issuingFee }} &euro;</td>
    </tr>
    <tr>
      <td>{{"ORDER.SUMMARY.ANNUAL_FEE" | translate}}</td>
      <td>{{ _product.annualFee }} &euro;</td>
    </tr>
    <tr *ngIf="_product.annualFee !== _product.annualFeeFromSecondYear">
      <td>{{"ORDER.SUMMARY.ANNUAL_FEE_FROM_SECOND_YEAR" | translate}}</td>
      <td>{{ _product.annualFeeFromSecondYear }} &euro;</td>
    </tr>
  </ng-container>

</table>
